/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type NotificationsListQueryLocal = {
    readonly hasNewNotifications: boolean | null;
    readonly " $refType": "NotificationsListQueryLocal";
};
export type NotificationsListQueryLocal$data = NotificationsListQueryLocal;
export type NotificationsListQueryLocal$key = {
    readonly " $data"?: NotificationsListQueryLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"NotificationsListQueryLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationsListQueryLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNewNotifications",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '76c96693838bc558b830893006e3c7fb';
export default node;
